import FeaturePage from "../../components/FeaturePage";
import { Building, Shield, Cog, FileCheck, Server, UserCheck } from "lucide-react";

export default function Enterprise() {
  return (
    <FeaturePage
      badge="For Enterprise"
      title="Custom-built to your scale."
      highlight=""
      subtitle="Dedicated infrastructure, signed SLAs, SSO, on-premise deployment options, and a customer success team that knows your business by name."
      heroImage="https://images.unsplash.com/photo-1763718528755-4bca23f82ac3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
      heroBg="cream"
      features={[
        { icon: <Building size={22} />, title: "Dedicated tenancy", desc: "Your own isolated infrastructure, fully managed and monitored." },
        { icon: <Shield size={22} />, title: "Enterprise security", desc: "SOC 2 Type II, ISO 27001, GDPR-ready data processing." },
        { icon: <Cog size={22} />, title: "Custom development", desc: "Our engineers build bespoke modules and integrations for you." },
        { icon: <FileCheck size={22} />, title: "Custom contracts", desc: "MSAs, DPAs, custom SLAs — handled by our legal team." },
        { icon: <Server size={22} />, title: "On-prem option", desc: "Deploy Brivo on your own infrastructure or private cloud." },
        { icon: <UserCheck size={22} />, title: "White-glove onboarding", desc: "Implementation team does the heavy lifting from day one." },
      ]}
      details={[
        {
          tag: "Reliability",
          title: "Uptime your CIO will smile about.",
          desc: "Signed 99.99% SLA, multi-region active-active deployment, 24/7 ops team. We treat every minute of your downtime like it's our own.",
          bullets: ["99.99% uptime SLA — guaranteed", "Multi-region failover", "24/7 named support team"],
        },
        {
          tag: "Compliance",
          title: "Audit-ready, always.",
          desc: "SOC 2, ISO 27001, GDPR, HIPAA-ready (BAA available). All your compliance teams' boxes — checked, with evidence.",
        },
      ]}
      useCases={[
        { title: "Public companies", desc: "SOX-ready audit trails and controls." },
        { title: "Global brands", desc: "Multi-region deployment & data residency." },
        { title: "Regulated industries", desc: "HIPAA, PCI-DSS, financial controls." },
        { title: "Government", desc: "FedRAMP-ready, on-prem options available." },
      ]}
      ctaTitle="Let's build it together."
      ctaSubtitle="Talk to our enterprise team about a custom implementation tailored to your scale."
      ctaAccent="mint"
    />
  );
}
